import $ from 'jquery';
import LP from '../0-lp';

LP.dlgResponseAction = {
  filterIds: [],

  prepare: function (selector, params) {
    $(selector).click(function () {
      if (!$(this).is('[disabled]')) {
        var width = 700;
        var height = 600;
        LP.Dialog.open(
          $.extend(params, {
            name: 'lp-responseaction',
            ajax: $(this).attr('url'),
            request: $(this).attr('url_params'),
            title: this.title,
            // width: 600,
            width: width,
            minHeight: height,
            maxHeight: height * 1.3,
            sizeable: true,
            onLoad: LP.dlgResponseAction.onLoad,
            onClose: LP.dlgResponseAction.onClose,
          })
        );
      }
      return false;
    });
  },

  onLoad: function () {
    var actionFilterBtn = $('a[action="actionFilterDialog"]', '#rsForm');

    LP.dlgItemFilter.prepare(actionFilterBtn, {
      afterSubmit: function (json) {
        LP.dlgRandomSelection.filterIds[LP.dlgResponseAction.filterIds.length] = json.filterId; // wird fürs cleanup unten gespeichert
        var block = actionFilterBtn.parent();
        $('.actionFilterId', block).val(json.filterId);
      },
    });

    $('#responseActionType', '#lp-responseaction').change(function () {
      LP.dlgResponseAction.onActionChange($(this).val());
    });
    $('#responseActionTrigger', '#lp-responseaction').change(function () {
      LP.dlgResponseAction.onTriggerChange($(this).val());
    });
    $('#responseAttrSelect', '#lp-responseaction').change(function () {
      var selected = $('#responseAttrSelect', '#lp-responseaction').val();
      if (selected === '__new__') {
        $('#responseAttrCustom', '#lp-responseaction').show();
      } else {
        $('#responseAttrCustom', '#lp-responseaction').hide();
      }
    });

    $('#responseActionAfter', '#lp-responseaction').change(function () {
      var selected = $('#responseActionAfter').val();
      if (selected === 'jumpToPage') {
        $('#responseActionPageTarget').show();
      } else {
        $('#responseActionPageTarget').hide();
      }
      if (selected === 'jumpToURL') {
        $('#responseActionURLTarget').show();
      } else {
        $('#responseActionURLTarget').hide();
      }
    });
  },

  onActionChange: function (value) {
    $('.responseActionTarget', '#lp-responseaction').hide();
    $('.responseActionTarget_' + value, '#lp-responseaction').show();
  },

  onTriggerChange: function () {},

  onClose: function () {
    if (LP.dlgResponseAction.filterIds.length > 0) {
      window.Browser.send('backend/clearItemFilterDialogCache/', $.param({filterids: LP.dlgResponseAction.filterIds}));
      LP.dlgResponseAction.filterIds = [];
    }
  },
};
